import { render } from "./Spinner.vue?vue&type=template&id=6448ed0e"
const script = {}

import "./Spinner.vue?vue&type=style&index=0&id=6448ed0e&lang=css"

import exportComponent from "D:\\PROJET WEB\\carpoolear\\carpoolear_frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__